import { sendCustom } from '@linecorp/dosi-analytics';
import { default as classnames } from 'classnames';
import { useEffect } from 'react';
import { T } from '~/components/I18n';
import circleCheck from '~/components/Icon/circle-check.png';
import { Confirm, ConfirmProps } from '~/components/Modal/Confirm/Confirm';
import styles from './AdventureSuccessPopup.module.scss';

export type AdventureSuccessPopupProps = Omit<ConfirmProps, 'id'> & {
  id: number;
  currentCount: number;
  maxCount: number;
};

export const AdventureSuccessPopup = ({
  id,
  currentCount,
  maxCount,
  className,
  ...props
}: AdventureSuccessPopupProps) => {
  useEffect(() => {
    sendCustom('join_adventure', {
      page_name: 'Adventure',
      join_num: currentCount,
      adventure_round: id,
    });
  }, [currentCount, id]);
  return (
    <Confirm
      className={classnames(styles.root, className)}
      icon={<img width={100} height={100} src={circleCheck} alt="join adventure succeed" />}
      title={<T name="citizen_adventure_joined_popup_title" />}
      description={
        <>
          <T name="citizen_adventure_join_num_my2" />
          <span className={styles.count}>{` ${currentCount}`}</span>
          <span className={styles.trial}>{` / ${maxCount}`}</span>
        </>
      }
      confirmText={<T name="citizen_adventure_joined_popup_btn1" />}
      dismissText={<T name="citizen_adventure_joined_popup_close" />}
      {...props}
    />
  );
};
